export default __webpack_public_path__ + "static/media/witmeg-reporting.bd29a02c.png";